export const notificationController = {

  successMessage(message) {
    alert(message);
  },

  errorMessage(message) {
    alert(message);
  }

}



// WEBPACK FOOTER //
// ./resources/js/global/global_notifications.js